<script>
import { ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { useLayoutStore } from "@shared/stores/layout.store";
import Skeleton from "primevue/skeleton";
import uploadPhotoService from "@shared/services/uploadPhoto.service";
import { required, helpers, minLength } from "@vuelidate/validators";
import { mapActions } from "pinia";
import { authMethods, notificationMethods } from "@shared/state/helpers";
import { useAuthStore } from "@shared/stores/auth.store";
import { useDataStore } from "@shared/stores/data.store";
import configurationService from "@shared/services/configuration.service";
export default {
  components: {
    Skeleton,
  },
  setup() {
    return {
      layoutStore: useLayoutStore(),
      authStore: useAuthStore(),
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      hotline:"",
      iconPassword: "ri-eye-line",
      iconPassword1: "ri-eye-line",
      passwordType: "password",
      passwordType1: "password",
      token: this.$route.query.token,
      email: this.$route.query.email,
      password: "",
      repassword: "",
      authError: null,
      processing: false,
      dataBanner: ref([]),
      urlLogo: null,
      typeBanner: "banner-login",
      typeLogo: "logo-login",
    };
  },

  created() {
    this.checkValid();
    this.getData();
    this.getDataLogo();
  },
  computed: {
    ...mapActions(useDataStore, [
      "initializeData",
      "getSetting",
      "fetchConfigs",
    ]),
    ...mapActions(useAuthStore, ["setPem"]),
    validInput() {
      return this.password && this.password == this.repassword;
    },
    disableButton() {
      return this.processing || !this.validInput;
    },
  },

  validations() {
    return {
      password: {
        required,
        minLength: minLength(6),
        containsLowerCase: helpers.withMessage(
          () => this.$t("login.error_pass_1"),
          (value) => /[a-z]/.test(value)
        ),
        containsUppercase: helpers.withMessage(
          () => this.$t("login.error_pass_2"),
          (value) => /[A-Z]/.test(value)
        ),
        containsNumber: helpers.withMessage(
          () => this.$t("login.error_pass_3"),
          (value) => /[0-9]/.test(value)
        ),
        containsSpecialCharacter: helpers.withMessage(
          () => this.$t("login.error_pass_4"),
          (value) => /[#?!@$%^&*-]/.test(value)
        ),
        noWhitespace: helpers.withMessage(
          () => this.$t("login.error_pass_6"),
          (value) => value.trim() === value
        ),
      },
    };
  },
  mounted() {},
  watch: {
    password() {
      this.disableButton;
    },
    repassword() {
      this.disableButton;
    },
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    switchPasswordType(){
      this.passwordType = this.passwordType === "password" ? "text" : "password";
      this.iconPassword = this.passwordType === "password" ? "ri-eye-line" : "ri-eye-off-line";
    },
    switchPasswordType1(){
      this.passwordType1 = this.passwordType1 === "password" ? "text" : "password";
      this.iconPassword1 = this.passwordType1 === "password" ? "ri-eye-line" : "ri-eye-off-line";
    },
    async checkValid() {
      const seft = this;
      this.layoutStore.toggleLoading();
      try {
        if (this.token == undefined || this.email == undefined) {
          this.$router.push({ name: "app.login" });
        } else {
          this.authStore
            .checkResetPassword({
              email: this.email,
              token: this.token,
            })
            .then((response) => {
              const data = response.data;
              if (!data.success) {
                this.$root.$showToast(this.$t("global.error_login"), {
                  type: "error",
                });
                setTimeout(function () {
                  seft.$router.push({ name: "app.login" });
                }, 1000);
              }
            })
            .catch(() => {
              this.$root.$showToast(this.$t("global.error_login"), {
                type: "error",
              });
            });
        }
      } catch (_) {
        //   this.$router.push({ name: 'app.login' })
      }
      this.layoutStore.toggleLoading();
    },
    async validateForm() {
      const result = await this.v$.$validate();
      if (!result) {
        return this.v$.$errors.map((error) => error.$message);
      }
      return [];
    },
    async resetPassword() {
      const seft = this;
      this.authError = await this.validateForm();
      if (this.authError.length > 0) {
        console.error(this.authError);
        this.$root.$showToast(this.authError, { type: "warn" });
        this.isLoading = false;
        return;
      }
      if (this.password != this.repassword) {
        this.$root.$showToast(this.$t("login.error_pass_5"), { type: "warn" });
        this.isLoading = false;
        return;
      }
      this.layoutStore.toggleLoading();
      this.authError = null;
      this.processing = true;
      this.isAuthError = false;
      this.authStore
        .savePassword({
          email: this.email,
          token: this.token,
          password: this.password,
          repassword: this.repassword,
        })
        .then((response) => {
          this.layoutStore.toggleLoading();
          let success = response.data.success;
          const data = response.data.data;

          this.$root.$showToast(this.$t(data.message), {
            type: success ? "success" : "error",
          });
          if (success) {
            setTimeout(function () {
              seft.$router.push("/");
            }, 2000);
          }
          this.processing = false;
          this.isAuthError = true;
        })
        .catch(() => {
          this.layoutStore.toggleLoading();
          this.processing = false;
          this.isAuthError = true;
        });
    },
    async getData() {
      await configurationService.getPublicConfig().then((setting) => {
        this.hotline =
          setting.data.content.company.children.general.children.phone.value;
      });
      const conditionsBanner = {
        status: 1,
        type: this.typeBanner,
      };
      uploadPhotoService.getBanner(conditionsBanner).then((response) => {
        this.dataBanner = response.data.data;
      });
    },
    async getDataLogo() {
      try {
        const response = await uploadPhotoService.getItem(this.typeLogo);
        if (response.data.data) {
          this.urlLogo = this.imageLink(
            this.typeLogo + "/" + response.data.data.name_file
          );
        }
      } catch (error) {
        console.error("Error while fetching data:", error);
      }
    },
  },
};
</script>

<template>
  <div class="auth-page-wrapper">
    <div class="auth-page-content bg-white p-1 p-md-4">
      <div class="wrap-login-panel">
      <div class="text-end mb-3">
                <div class="dropdown">
                  <a
                    href="#"
                    class="btn btn-primary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <inline-svg
                      src="assets/icon/support.svg"
                      width="33"
                      height="24"
                      fill="black"
                    ></inline-svg>
                    {{ $t("login.support247") }}
                  </a>
                  <ul class="dropdown-menu">
                    <li v-if="hotline != null">
                      <a
                        class="dropdown-item text-primary fw-bold"
                        :href="`tel:${hotline}`"
                        >{{ hotline }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
      <BRow class="align-items-center justify-content-center m-0">
        <BCol md="5" lg="4" xl="4" class="p-0">
          <BCard no-body class="p-1 p-md-4  border-0 shadow-none">
            <!-- Logo section -->
            <div class="wrap-login-panel">
              <div class="text-center mb-4 text-white-50">
                <div>
                  <router-link to="/" class="d-inline-block auth-logo">
                    <img
                      v-if="urlLogo"
                      :src="urlLogo"
                      alt=""
                      width="200"
                      height="200"
                      style="max-width: 100%"
                    />
                    <template v-else>
                      <Skeleton shape="circle" size="165px"></Skeleton>
                    </template>
                  </router-link>
                </div>
              </div>

              <!-- Form section -->
              <div class="text-center mt-2 title-login">
                <h2 class="m-0">{{ $t("login.set_password") }}</h2>
                <p class="m-0 my-2">{{ $t("login.set_password_desc") }}</p>
              </div>

              <div class="p-0 mt-2">
                <form @submit.prevent="resetPassword">
                  <!-- Password fields -->
                  <div class="mb-3">
                    <label for="password" class="form-label">{{
                      $t("login.password")
                    }}</label>
                    <div class="position-relative">
                    <input
                      :type="passwordType"
                      class="form-control"
                      id="password"
                      :placeholder="$t('login.password')"
                      v-model="password"
                    />
                    <span class="position-absolute top-50 end-0 translate-middle-y me-2">
                      <span @click="password = ''" v-if="password" class="cursor-pointer  end-0 translate-middle-y me-2">
                      <i class=" ri-close-line fs-3"></i>
                      </span>
                      <span @click="switchPasswordType()" class="cursor-pointer  end-0 translate-middle-y me-2">
                      <i class="fs-3" :class="iconPassword"></i>
                      </span>
                      </span> 
                  </div>
                  </div>

                  <div class="mb-3">
                    <label for="repassword" class="form-label">{{
                      $t("login.repassword")
                    }}</label>
                    <div class="position-relative">
                    <input
                       :type="passwordType1"
                      class="form-control"
                      id="repassword"
                      :placeholder="$t('login.repassword')"
                      v-model="repassword"
                    />
                    <span class="position-absolute top-50 end-0 translate-middle-y me-2">
                      <span @click="repassword = ''" v-if="repassword" class="cursor-pointer  end-0 translate-middle-y me-2">
                      <i class=" ri-close-line fs-3"></i>
                      </span>
                      <span @click="switchPasswordType1()" class="cursor-pointer  end-0 translate-middle-y me-2">
                        <i class="fs-3" :class="iconPassword1"></i>
                      </span> 
                      </span> 
                  </div>
                  </div>

                  <!-- Submit button -->
                  <div class="mt-4">
                    <BButton
                      class="w-100"
                      type="submit"
                      :disabled="disableButton"
                      :loading="processing"
                      loadingText="Please wait"
                    >
                      {{ $t("global.update") }}
                    </BButton>
                  </div>

                  <!-- Back to login link -->
                  <div class="my-2 my-md-3">
                    <router-link
                      :to="{ name: 'app.login' }"
                      class="w-100 text-primary py-3 text-center fs-5 d-block"
                    >
                      {{ $t("login.back_to_login") }}
                    </router-link>
                  </div>
                </form>
              </div>
            </div>
          </BCard>
        </BCol>
      </BRow>
    </div>
    </div>
  </div>
</template>
